import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { experimentVariantSelector } from 'redux/modules/experiments/selectors';

export default function useExperiment(experimentName: string) {
  const activeVariant = useSelector(experimentVariantSelector(experimentName));
  const selectVariant = useCallback(
    function selectVariant<T>(
      variants: { [k in string]?: T },
      fallback?: T,
    ): T | undefined {
      return variants[activeVariant] ?? fallback;
    },
    [activeVariant],
  );

  return {
    activeVariant,
    selectVariant,
  };
}
